import { SearchType } from '~/components/search/enums/SearchType'

import { AlgoliaIndices } from '~/components/search/enums/AlgoliaIndices'

import { SortByOption } from '~/types/SortByOption'

export const handleToIndexName = (prefix: string, index: string): string => {
  return `${prefix}${index}`
}

export const getProductSortByOptions = (prefix: string): SortByOption[] => ([
  { value: handleToIndexName(prefix, AlgoliaIndices.MOST_POPULAR), label: 'Most Popular' },
  { value: handleToIndexName(prefix, AlgoliaIndices.PRIMARY), label: 'Best Match' },
  { value: handleToIndexName(prefix, AlgoliaIndices.UPDATED_DESC), label: 'Most Recent' },
  { value: handleToIndexName(prefix, AlgoliaIndices.PRICE_ASC), label: 'Price (Low to High)' },
  { value: handleToIndexName(prefix, AlgoliaIndices.PRICE_DESC), label: 'Price (High to Low)' },
  { value: handleToIndexName(prefix, AlgoliaIndices.TITLE_ASC), label: 'Title (A-Z)' },
  { value: handleToIndexName(prefix, AlgoliaIndices.TITLE_DESC), label: 'Title (Z-A)' },
])

export const getBlogSortByOptions = (prefix: string): SortByOption[] => ([
  {value: handleToIndexName(prefix, AlgoliaIndices.PRIMARY), label: 'Best Match'},
  {value: handleToIndexName(prefix, AlgoliaIndices.POSTDATE_DESC), label: 'Most Recent'},
])


export const getSortByOptionsBySearchType = (searchType: SearchType, prefix: string): SortByOption[] => {
  switch (searchType) {
    case SearchType.PRODUCT:
      return getProductSortByOptions(prefix)
    case SearchType.BLOG:
      return getBlogSortByOptions(prefix)
    default:
      return []
  }
}

export default {
  handleToIndexName,
  getProductSortByOptions,
  getBlogSortByOptions,
  getSortByOptionsBySearchType,
}
